module.exports = __webpack_public_path__ + "img/almacen.74aff853.jpeg";